import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_DELIVERY_OPTION } from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class DeliveryOptionValidator extends BaseValidator {
  properties = [
                 'contents',
                 'attentions',
                 'position'
               ];
  validContents(){
    let contents = this.newVal.inputs.contents.value;
    let isValid = this.require('contents', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validAttentions(){
    let attentions = parseInt(this.newVal.inputs.attentions.value);
    let isValid = !isNaN(attentions) && attentions >= 1 && attentions <= 7;
    let message;
    if(!isValid){
      message = this.messages.delivery_option.attentions.valid
      this.newVal.error = true;
    }
    this.addMessage(this.newVal.inputs.attentions, message);
    return this.newVal;
  }
  // validPosition(){
  // }
}
export const validDeliveryOption = function*(){
  yield takeEvery(VALID_DELIVERY_OPTION, function*(action: FSA<any, any>){
    let validator;
    validator = new DeliveryOptionValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('contents')){
      validator.validContents();
    }
    if(validator.targetIs('attentions')){
      validator.validAttentions();
    }
    // if(validator.targetIs('position')){
    //   validator.validPosition();
    // }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
